import { ContentProps } from '@/features/Listings/seo/types'

import Content from './content'

const SearchResultsContent = ({
  cityData,
  neighborhoodData,
  metadata,
  filterSlug
}: ContentProps) => {
  return (
    <Content
      cityData={cityData}
      neighborhoodData={neighborhoodData}
      metadata={metadata}
      filterSlug={filterSlug}
    />
  )
}

export default SearchResultsContent
